import React, { useEffect, useState } from "react";
import { meApi, formatApiError } from "@/lib/api";
import { PageHeader, Card, Field, TextArea, SaveBar } from "./_shared";
import { toast } from "sonner";
import QuestionnaireConfirmationModal, { CompletedBadge } from "@/components/QuestionnaireConfirmationModal";

const FIELDS_1 = [
  ["nom_couple", "Nom du couple (ou des fêtés)"],
  ["date_mariage", "Date de l'événement", "date"],
  ["lieu_ceremonie", "Lieu de la cérémonie"],
  ["lieu_reception", "Lieu de la réception"],
  ["nb_invites", "Nombre d'invités"],
  ["personne_contact", "Personne de contact le jour J"],
  ["telephone_contact", "Téléphone contact jour J"],
];
const FIELDS_HORAIRES = [
  ["horaire_arrivee", "Arrivée DJ", "time"],
  ["horaire_repas", "Début du repas", "time"],
  ["horaire_ouverture_bal", "Ouverture du bal", "time"],
  ["horaire_fin", "Fin de soirée", "time"],
];

export default function Questionnaire() {
  const [data, setData] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(""); const [err, setErr] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    meApi.getQuestionnaire().then((r) => {
      setData(r || {});
      if (r && (r.created_at || r.id)) setCompleted(true);
    }).catch(() => {});
  }, []);
  const upd = (k) => (v) => setData((d) => ({ ...d, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); setErr(""); setSaving(true);
    try {
      const r = await meApi.saveQuestionnaire(data);
      setData(r);
      setCompleted(true);
      if (r?.first_submit) {
        setShowConfirmation(true);
      } else {
        setMsg("Questionnaire enregistré.");
        toast.success("Questionnaire enregistré.");
      }
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="ec-questionnaire">
      <QuestionnaireConfirmationModal
        open={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        isWedding={true}
      />
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <PageHeader eyebrow="Préparation" title="Questionnaire" italic="mariage." desc="Plus vous nous en dites, plus votre soirée nous ressemble." />
        {completed && <div className="mt-4"><CompletedBadge label="Questionnaire complété" /></div>}
      </div>
      <Card>
        <form onSubmit={submit} className="space-y-6">
          <h2 className="font-serif-luxe text-xl">Informations générales</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {FIELDS_1.map(([k, label, type]) => (
              <Field key={k} label={label} type={type || "text"} value={data[k]} onChange={upd(k)} testid={`q-${k}`} />
            ))}
          </div>

          <h2 className="font-serif-luxe text-xl pt-4 border-t border-[#DCB457]/15">Horaires</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {FIELDS_HORAIRES.map(([k, label, type]) => (
              <Field key={k} label={label} type={type} value={data[k]} onChange={upd(k)} testid={`q-${k}`} />
            ))}
          </div>

          <h2 className="font-serif-luxe text-xl pt-4 border-t border-[#DCB457]/15">Ambiance & musique</h2>
          <Field label="Style musical souhaité" value={data.style_musical} onChange={upd("style_musical")} placeholder="ex. années 80, pop FR, latino…" testid="q-style" />
          <TextArea label="Ambiance souhaitée" rows={3} value={data.ambiance_souhaitee} onChange={upd("ambiance_souhaitee")} testid="q-ambiance" />
          <TextArea label="Animations spéciales / surprises" rows={3} value={data.animations_speciales} onChange={upd("animations_speciales")} testid="q-anims" />
          <TextArea label="Contraintes sonores (voisinage, salle…)" rows={3} value={data.contraintes_sonores} onChange={upd("contraintes_sonores")} testid="q-contraintes" />
          <TextArea label="Notes complémentaires" rows={3} value={data.notes} onChange={upd("notes")} testid="q-notes" />

          {err && <p className="text-xs text-red-300">{err}</p>}
          <SaveBar saving={saving} message={msg} />
        </form>
      </Card>
    </div>
  );
}
